import classnames from 'classnames/bind';

import { RECOMMEND_RULE_LIST } from '@portalCommon/constants';
import { TitleText } from '@portalCommon/recommend';
import { OptimizedImg } from '@commonPackage/components';
import { EditionBlock } from '..';
import styles from './index.module.less';

const cx = classnames.bind(styles);

// 活动规则
export function ActivityRule() {
  return (
    <EditionBlock className={cx('activity-rule')}>
      <TitleText text="活动规则" />
      <div className={cx('rule-box')}>
        <ul>
          {RECOMMEND_RULE_LIST.map((item, index) => (
            <li key={index}>
              {item.text}
              {item.child?.map((childItem, childIndex) => (
                <p key={childItem} className={cx({ 'hight-color': index === 5 && childIndex === 4 })}>
                  {childItem}
                </p>
              ))}
              {item.roundText?.map(roundTextItem => (
                <p key={roundTextItem} className={cx('round')}>
                  {roundTextItem}
                </p>
              ))}
            </li>
          ))}
        </ul>
        <div className={cx('rule-tip')}>
          <span>更多活动详情请扫码咨询</span>
          <div>
            <OptimizedImg
              loading="lazy"
              src="https://static.fuxi.netease.com/yaotai/portal/index/lj28yomj_297899.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </EditionBlock>
  );
}
